<template>
  <div class="container" :class="isMobile() ? 'mobile' : ''">
    <div class="top-box">
      <img src="https://zk-web-source.oss-cn-beijing.aliyuncs.com/tg/health_exam_2023_bg.png" alt="" />
      <h1>2023年卫生专业技术资格考试成绩</h1>
      <span>考生登录查询平台</span>
    </div>
    <div class="info-box">
      <div class="box1"></div>
      <div class="box2"></div>
      <div class="main-box">
        <div class="l-box">
          <span>温馨提示</span>
          <div class="title-label">1.信息填写</div>
          <p>在此提交您的准考证号免费订阅成绩查询及预约服务，您的准考证号及手机号是成绩查询与信息接收的重要依据，请您认真核对后提交。</p>
          <div class="title-label" style="margin-top: 34px">2.成绩查询</div>
          <p>在此提交您的准考证号免费订阅成绩查询及预约服务，成绩结果将以短信或人工形式发送至您的手机号，请认真核对手机号，等待报考老师联系</p>
        </div>
        <div class="r-box">
          <div class="inpu-box">
            <input type="text" placeholder="请输入报考姓名" v-model="formData.name" />
            <input type="text" style="margin-top: 15px" placeholder="请输入手机号（已加密,仅供查询使用）" v-model="formData.mobile" />
            <button @click="onSubmit">成绩预约查询</button>
          </div>
        </div>
        <img src="https://zk-web-source.oss-cn-beijing.aliyuncs.com/tg/health_exam_2023_b_icon.png" alt="" class="bottom-img" />
      </div>
    </div>
  </div>
</template>
<script>
import { Message, MessageBox } from 'element-ui'
import md5 from 'js-md5'
import { phoneValidator } from '@/utils/index'
import { graduatePromot } from '@/api'
export default {
  data() {
    return {
      formData: {
        name: '',
        mobile: ''
      },
      isSubmit: false
    }
  },
  methods: {
    isMobile() {
      let flag = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
      return flag
    },
    onSubmit() {
      if (!this.formData.name.length) {
        return Message.error('请输入您的姓名')
      }
      if (!this.formData.mobile.length) {
        return Message.warning('请输入您的手机号')
      }
      if (!phoneValidator(this.formData.mobile)) {
        return Message.warning('请输入正确的手机号')
      }
      if (this.isSubmit) {
        return
      }
      this.isSubmit = true

      const gt = new Date().getTime().toString()

      graduatePromot({
        time: gt,
        encryPwd: md5(gt + 'verify'),
        name: this.formData.name,
        mobile: this.formData.mobile,
        collegeName: '考研',
        orign: '百度信息流',
        promotedAccount: '中课网校16-D',
        url: this.$route.query.bd_vid ? window.location.href : ''
      })
        .then(res => {
          MessageBox.alert('预约成功  相关老师将于24小时内和您联系 请注意接听！', '提示', {
            confirmButtonText: '确定',
            callback: action => {
              this.formData.mobile = ''
              this.formData.name = ''
            }
          })
        })
        .finally(() => {
          this.isSubmit = false
        })
    }
  }
}
</script>
<style>
body {
  min-width: 100%;
}
</style>
<style lang="scss" scoped>
.container {
  .top-box {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 470px;
    box-sizing: border-box;
    & > img {
      position: absolute;
      width: 100%;
      height: 470px;
      z-index: 0;
      object-fit: cover;
    }
    h1 {
      position: relative;
      font-size: 60px;
      font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
      font-weight: bold;
      color: #ffffff;
      text-shadow: 2px 0px 8px #318ff7;
    }
    span {
      position: relative;
      margin-top: 20px;
      font-size: 46px;
      font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
      font-weight: bold;
      color: #ffffff;
      text-shadow: 2px 0px 8px #318ff7;
    }
  }
  .info-box {
    position: relative;
    margin: 0 auto;
    height: 530px;
    .bottom-img {
      position: absolute;
      right: 0;
      bottom: 0;
      width: 223px;
      height: 223px;
      margin-right: 23px;
      margin-bottom: 23px;
    }
    .box1 {
      position: absolute;
      width: 1112px;
      height: 520px;
      margin: -80px auto 0;
      background: rgba(255, 255, 255, 0.4);
      border-radius: 16px;
      left: 50%;
      transform: translateX(-50%);
    }
    .box2 {
      position: absolute;

      width: 1156px;
      height: 520px;
      margin: -65px auto 0;
      background: rgba(255, 255, 255, 0.6);
      border-radius: 16px 16px 16px 16px;
      left: 50%;
      transform: translateX(-50%);
    }
    .main-box {
      position: absolute;
      margin: -45px auto;
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 1215px;
      height: 535px;
      box-sizing: border-box;
      background: #ffffff;
      box-shadow: 2px 0px 8px 0px #e1e1e1;
      border-radius: 16px 16px 16px 16px;
      border: 1px solid #e5e5e5;
      left: 50%;
      transform: translateX(-50%);
      padding: 0 143px 0 98px;
      .l-box {
        display: flex;
        flex-direction: column;

        margin-right: 57px;
        & > span {
          font-size: 32px;
          font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
          font-weight: bold;
          color: #328ff7;
          margin-bottom: 54px;
        }
        .title-label {
          font-size: 20px;
          font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
          font-weight: bold;
          color: #212121;
          margin-bottom: 15px;
        }
        p {
          font-size: 16px;
          font-family: MicrosoftYaHei;
          color: #212121;
          line-height: 26px;
        }
      }

      .r-box {
        flex-shrink: 0;
        width: 511px;
        height: 321px;
        background: #ffffff;
        box-shadow: 2px 0px 6px 0px #e6e6e6;
        border-radius: 10px 10px 10px 10px;
        border: 1px solid #e5e5e5;
        .inpu-box {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          height: 100%;
          input {
            width: 402px;
            height: 50px;
            padding-left: 16px;
            background: #ffffff;
            border-radius: 5px 5px 5px 5px;
            border: 1px solid #cbcbcb;
            outline: none;
          }
          button {
            margin-top: 35px;
            width: 400px;
            height: 48px;
            background: #318ff7;
            border-radius: 5px 5px 5px 5px;
            color: #ffffff;
            outline: none;
            border: none;
            cursor: pointer;
          }
        }
      }
    }
  }
}

.mobile {
  .top-box {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 200px;
    & > img {
      width: 100%;
      height: 200px;
      z-index: 0;
    }
    h1 {
      font-size: 20px;
    }
    span {
      margin-top: 20px;
      font-size: 16px;
    }
  }
  .info-box {
    margin: 0 auto;
    .bottom-img {
      display: none;
    }
    .box1,
    .box2 {
      display: none;
    }

    .main-box {
      position: absolute;
      margin: -45px auto;
      display: flex;
      align-items: center;
      flex-direction: column;
      width: 100%;
      height: auto;
      padding: 0;
      .l-box {
        display: flex;
        flex-direction: column;
        margin-right: 0px;
        padding: 16px;
        order: 1;
        & > span {
          font-size: 18px;
          margin-bottom: 15px;
        }
        .title-label {
          font-size: 14px;
          color: #212121;
          margin-bottom: 10px;
        }
        p {
          font-size: 14px;
          line-height: 120%;
        }
      }

      .r-box {
        flex-shrink: 0;
        order: 0;
        width: 90vw;
        height: auto;
        box-shadow: none;
        border-radius: 0;
        border: none;
        margin-top: 32px;
        .inpu-box {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          input {
            width: 85%;
            height: 44px;
            outline: none;
          }
          button {
            margin-top: 10px;
            width: 100%;
            height: 44px;
            outline: none;
            border: none;
          }
        }
      }
    }
  }
}

@media (min-width: 993px) and (max-width: 1280px) {
  .container {
    .top-box {
      height: 280px;
      h1 {
        font-size: 45px;
      }
      span {
        margin-top: 0px;
        font-size: 30px;
      }
      & > img {
        height: 100%;
      }
    }
    .info-box {
      zoom: 80%;
    }
  }
}

@media (min-width: 1281px) and (max-width: 1920px) {
  .container {
    .info-box {
      zoom: 95%;
    }
  }
}
</style>
